import { createReducer, on } from '@ngrx/store';
import { setBrokerSessionInfo } from './auth.actions';
import { LocalStorageService } from '../common/services/local-storage.service';

const localStorageService = new LocalStorageService();

export const initialState = localStorageService.get('brokerSessionInfo');

export const brokerSessionInfoReducer = createReducer(
  initialState,
  on(setBrokerSessionInfo, (state, { brokerSessionInfo }) => brokerSessionInfo)
);
